import request from '@/utils/request'
// 投票活动管理
const url = '/api/learn.HbrbJpk/'
/**
 * 活动信息
 * @param {array} params 请求参数
 */
export function reqLearnInfo(params) {
  return request({
    url: url + 'info',
    method: 'get',
    params: params
  })
}

/**
 * 活动扩展信息
 * @param {array} params 请求参数
 */
export function reqLearnExtend(params) {
  return request({
    url: url + 'extend',
    method: 'get',
    params: params
  })
}

/**
 * 分组列表
 * @param {array} params 请求参数
 */
export function reqGroups(params) {
  return request({
    url: url + 'groups',
    method: 'get',
    params: params
  })
}

/**
 * 课程列表
 * @param {array} params 请求参数
 */
export function reqLessions(params) {
  return request({
    url: url + 'lessions',
    method: 'get',
    params: params
  })
}

/**
 * 课程详情
 * @param {array} params 请求参数
 */
export function reqLessionsInfo(params) {
  return request({
    url: url + 'show',
    method: 'get',
    params: params
  })
}

/**
 * 用户详情
 * @param {array} params 请求参数
 */
export function reqUserInfo(params) {
  return request({
    url: url + 'userinfo',
    method: 'get',
    params: params
  })
}

/**
 * 获取用户id
 * @param {array} params 请求参数
 */
export function reqGetUid(params) {
  return request({
    url: url + 'getUid',
    method: 'get',
    params: params
  })
}

/**
 * 用户登记
 * @param {array} params 请求参数
 */
export function reqIsReg(params) {
  return request({
    url: url + 'isreg',
    method: 'get',
    params: params
  })
}

/**
 * 用户登记
 * @param {array} params 请求参数
 */
export function reqUserAdd(params) {
  return request({
    url: url + 'add',
    method: 'get',
    params: params
  })
}


/**
 * 观看开始线
 * @param {array} params 请求参数
 */
export function reqWatchTime(params) {
  return request({
    url: url + 'watchTime',
    method: 'get',
    params: params
  })
}

/**
 * 增加学习分值
 * @param {array} params 请求参数
 */
export function reqAddScore(params) {
  return request({
    url: url + 'addScore',
    method: 'get',
    params: params
  })
}


/**
 * 查询用户是否进行指定课程的答题
 * @param {array} params 请求参数
 */
export function reqIsAnswer(params) {
  return request({
    url: url + 'isAnswer',
    method: 'get',
    params: params
  })
}

/**
 * 提交课程答题
 * @param {array} params 请求参数
 */
export function reqSubAnswer(params) {
  return request({
    url: url + 'subAnswer',
    method: 'get',
    params: params
  })
}

